import type { BillingPlan } from '@core/billing-types';

export const getProductSafeSlotsCount = (
  product: BillingPlan,
  {
    slotsTotal,
    jobSlotsUsed,
  }: {
    slotsTotal: number;
    jobSlotsUsed: number;
  },
) => Math.max(product.baseSlots, Number.isFinite(slotsTotal) ? slotsTotal : jobSlotsUsed);
